import $ from 'jquery';

$( '.logo-slider' ).slick( {
	slidesToShow: 7, // Foundation breakpoint XLarge
	dots: false,
	prevArrow: false,
	nextArrow: false,
	autoplay: true,
	autoplaySpeed: 80000,
	responsive: [
		{
			breakpoint: 1024, // Foundation Large
			settings: { slidesToShow: 6 }
		},
		{
			breakpoint: 640, // Foundation Medium
			settings: { slidesToShow: 5 }
		},
		{
			breakpoint: 480, // Foundation Small
			settings: { slidesToShow: 4 }
		},
	]
} );
